// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Documentos_BuscaorcamentopdfResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaOrcamentoPDF /documentos/buscaOrcamentoPDF
 * Proxy to html2pdf-service busca endpoint for quote PDF documents.
 *
 * Each item is the shape of html2pdf-service's `document.Document` GORM model
 * serialised as JSON — the same struct that backs /documentos/buscaRecibo, so
 * we reuse `Documentos_BuscareciboRow` rather than declaring a sibling class.
 * The Go side hits the same `GET /v1/busca/:tipo/:owner/:ownerid` handler;
 * only the `:tipo` segment differs ("orcamento" vs. "recibo"), and that
 * doesn't change the row shape — see entity.go for the source struct and
 * Documentos_BuscareciboRow for the field-by-field doc.
 */
import type { Documentos_BuscareciboRow } from './Documentos_BuscareciboRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Documentos_BuscaorcamentopdfResponseDados = Documentos_BuscareciboRow[];

export type Documentos_BuscaorcamentopdfResponse = ApiResponse<Documentos_BuscaorcamentopdfResponseDados>;

registerResponseContract('Documentos_BuscaorcamentopdfResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'number',  required: false },
      CreatedAt: { type: 'string',  required: false },
      UpdatedAt: { type: 'string',  required: false },
      DeletedAt: { type: 'string',  required: false },
      Type:      { type: 'string',  required: false },
      Owner:     { type: 'string',  required: false },
      OwnerID:   { type: 'number',  required: false },
      Src:       { type: 'string',  required: false },
    },
  },
})
